import { BrowserInfo } from './browser-metadata';

export function detectBrowser(userAgent = navigator.userAgent): BrowserInfo {
  const ua = userAgent || '';

  const candidates: Array<{ name: string; pattern: RegExp }> = [
    { name: 'Edge', pattern: /Edg\/([\d.]+)/ },
    { name: 'Chrome', pattern: /Chrome\/([\d.]+)/ },
    { name: 'Firefox', pattern: /Firefox\/([\d.]+)/ },
    { name: 'Safari', pattern: /Version\/([\d.]+).*Safari/ },
  ];

  for (const candidate of candidates) {
    const match = ua.match(candidate.pattern);
    if (match?.[1]) {
      return {
        name: candidate.name,
        version: match[1],
        userAgent: ua,
        language: navigator.language,
        platform: navigator.platform,
        vendor: navigator.vendor,
      };
    }
  }

  return {
    name: 'Unknown',
    version: 'Unknown',
    userAgent: ua,
    language: navigator.language,
    platform: navigator.platform,
    vendor: navigator.vendor,
  };
}

export function detectOs(userAgent = navigator.userAgent): string {
  const ua = userAgent.toLowerCase();

  if (ua.includes('windows nt 11')) return 'Windows 11';
  if (ua.includes('windows nt 10')) return 'Windows 10';
  if (ua.includes('windows nt 6.3')) return 'Windows 8.1';
  if (ua.includes('mac os x')) return 'macOS';
  if (ua.includes('android')) return 'Android';
  if (ua.includes('iphone') || ua.includes('ipad') || ua.includes('ios')) return 'iOS';
  if (ua.includes('linux')) return 'Linux';

  return 'Unknown';
}

export function detectDeviceType(width = window.innerWidth): 'desktop' | 'tablet' | 'mobile' {
  if (width < 768) return 'mobile';
  if (width < 1024) return 'tablet';
  return 'desktop';
}
